const SESSION_KEY = "userDetails";

const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY));
  } catch {
    return null;
  }
};

export const getAccessToken = () => getSession()?.accessToken ?? null;

export const getRefreshToken = () => getSession()?.refreshToken ?? null;

export const clearTokens = () => {
  localStorage.removeItem(SESSION_KEY);
};